const InstitutionalSchema = (props) => ({
  title: 'AgSUS Institucional',
  fieldsets: [
    {
      id: 'default',
      title: 'Destaque',
      fields: ['badge', 'title', 'description', 'ctaLabel', 'ctaHref', 'featuredImage', 'featuredImageUrl'],
    },
    { id: 'cards', title: 'Cards', fields: ['cards'] },
  ],
  properties: {
    badge: { title: 'Eyebrow (rótulo)', default: 'INSTITUCIONAL' },
    title: { title: 'Título', widget: 'textarea' },
    description: { title: 'Descrição', widget: 'textarea' },
    ctaLabel: { title: 'Label do botão', default: 'Leia mais' },
    ctaHref: { title: 'URL do botão' },
    featuredImage: {
      title: 'Imagem do destaque (do Plone)',
      description: 'Imagem à esquerda da linha de destaque. Sobrescreve a URL externa.',
      widget: 'object_browser',
      mode: 'image',
      allowExternals: false,
      selectableTypes: ['Image'],
    },
    featuredImageUrl: {
      title: 'URL da imagem do destaque (fallback)',
      description: 'Use só se não houver imagem do Plone selecionada.',
    },
    cards: {
      title: 'Cards (até 4)',
      widget: 'object_list',
      schema: {
        title: 'Card',
        fieldsets: [{ id: 'default', title: 'Default', fields: ['title', 'href', 'image', 'imageUrl'] }],
        properties: {
          title: { title: 'Texto do card', widget: 'textarea' },
          href: { title: 'Link do card' },
          image: {
            title: 'Imagem (do Plone)',
            description: 'Selecione uma Image content. Sobrescreve URL externa.',
            widget: 'object_browser',
            mode: 'image',
            allowExternals: false,
            selectableTypes: ['Image'],
          },
          imageUrl: {
            title: 'URL de imagem externa (fallback)',
            description: 'Use só se não houver imagem do Plone selecionada.',
          },
        },
        required: ['title'],
      },
    },
  },
  required: [],
});

export default InstitutionalSchema;
